import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MissedVideoCallIcon from "@mui/icons-material/MissedVideoCall";
import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import BasicModal from "./ImageModal";
import RenderPhotos from "./RenderPhotos";
import Snackbar1 from "./Snaclbar";
import "./styles.css";
import "./postbid-modern.css";

const UploadPhotoUpdate = ({ setImages, bidImages, size1, imagesSize, publicid }) => {
  const urls = (bidImages || "").split(",").filter(Boolean);
  const sizes = (imagesSize || "").split(",");
  const publicIds = (publicid || "").split(",");
  const existingFiles = urls.map((url, i) => ({ url, type: "image", from: "cloud", size: parseInt(sizes[i] || "0", 10), publicid: publicIds[i] || "" }));

  const [bidImages1, setBidImages] = useState(existingFiles);
  const [error, setError] = useState(false);
  const [size, setSize] = useState(Number(size1) || 0);
  const [fileError, setFileError] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(existingFiles);
  const [selectedImages, setSelectedImages] = useState([]);
  const [open, setOpen] = useState(false);
  const sha1 = require("sha1");

  const handleImageChange = (e) => {
    setError(false);
    setFileError(false);
    const incoming = Array.from(e.target.files || []);
    const validFiles = incoming.filter((file) => {
      if (file.size > 10 * 1024 * 1024) { setFileError(true); return false; }
      return true;
    });
    const newTotal = validFiles.reduce((sum, file) => sum + file.size, size);
    setSize(newTotal);
    if (newTotal > 30 * 1024 * 1024) setError(true);
    setSelectedImages((previous) => previous.concat(validFiles));
    setSelectedFiles((previous) => previous.concat(validFiles.map((file) => ({ url: URL.createObjectURL(file), type: file.type, size: file.size, from: "device", file }))));
  };

  function deleteHandler(image) {
    if (image.from === "cloud") {
      const timestamp = new Date().getTime();
      const string = `public_id=${image.publicid}&timestamp=${timestamp}${process.env.React_App_CLOUDINARY_SECRET}`;
      const signature = sha1(string);
      const formData = new FormData();
      formData.append("public_id", image.publicid);
      formData.append("signature", signature);
      formData.append("api_key", `${process.env.React_App_CLOUDINARY_API}`);
      formData.append("timestamp", timestamp);
      axios.post(`https://api.cloudinary.com/v1_1/${process.env.React_App_CLOUDINARY_CLOUD_NAME}/image/destroy`, formData)
        .then(() => {
          setBidImages((previous) => previous.filter((item) => item.url !== image.url));
          setSelectedFiles((previous) => previous.filter((item) => item !== image));
        }).catch((err) => console.log(err));
      return;
    }
    setSize((previous) => Math.max(0, previous - (image.size || 0)));
    setSelectedImages((previous) => previous.filter((file) => file !== image.file));
    setSelectedFiles((previous) => previous.filter((item) => item !== image));
    if (image.url) URL.revokeObjectURL(image.url);
  }

  const uploadImages = () => {
    setOpen(false);
    if (size > 30 * 1024 * 1024) { setError(true); return; }
    setImages(selectedImages, size, bidImages1);
  };

  return (
    <Box className="bidit-upload-card" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      <Box className="bidit-form-intro bidit-upload-intro">
        <Box className="bidit-form-intro-badge"><span className="bidit-form-intro-spark">✦</span>עריכת מדיה</Box>
        <Typography variant="h6" className="bidit-form-title" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>תמונות וסרטונים</Typography>
        <Typography className="bidit-form-subtitle" sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>אפשר להשאיר את המדיה הקיימת, להסיר אותה או להוסיף קבצים חדשים</Typography>
      </Box>
      {fileError && <Snackbar1 />}
      {error && <Box className="bidit-inline-error">סה"כ הקבצים יכול להיות עד 30MB.</Box>}

      <Button variant="outlined" className="bidit-upload-button" component="label" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, m: "0 8px 10px" }}>
        <span style={{ marginLeft: 5 }}>הוספת תמונה</span><AddAPhotoIcon />
        <input hidden multiple type="file" accept="image/*" onChange={handleImageChange} />
      </Button>
      <Button variant="outlined" className="bidit-upload-button" component="label" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, m: "0 8px 10px" }}>
        <span style={{ marginLeft: 5 }}>הוספת סרטון</span><MissedVideoCallIcon />
        <input hidden multiple type="file" accept="video/*" onChange={handleImageChange} />
      </Button>
      <Button variant="outlined" className="bidit-upload-continue" onClick={selectedImages.length > 0 ? () => setOpen(true) : uploadImages} sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mb: 1 }}>
        <span>{selectedImages.length > 0 ? "שמירה והמשך" : "המשך ללא שינוי במדיה"}</span><CloudUploadIcon sx={{ p: .5 }} />
      </Button>

      <Box><RenderPhotos source={selectedFiles} deleteHandler={deleteHandler} /></Box>
      {open && <BasicModal handleOpen={() => setOpen(true)} handleClose={() => setOpen(false)} setOpen={setOpen} open={open} cancel={error} uploadImages={uploadImages} />}
    </Box>
  );
};
export default UploadPhotoUpdate;
